
import Logo from '../../misc/Logo'
import { Link } from 'react-router-dom'
import { Icons } from '../../misc/Icons'
import { store } from '../../stores/Store'
import TruncText from '../../misc/TruncText'
import { IconButton, Button } from '@mui/material'
import SystemInformation from '../../misc/SystemInformation'
import { observer } from 'mobx-react-lite'

interface MainMenuProps {
    handleClose: Function;
}

export default observer(function MainMenu({handleClose}: MainMenuProps) {

    const logoPath = store.AppStore.sessionInfo?.customLogoUrl
    const supportUrl = store.AppStore.sessionInfo?.accountPreferences?.support_url
    const userAccountUid = store.AppStore.sessionInfo.userAccount?.uid
    const account = store.NodeStore.accounts?.find(a => a.uid === userAccountUid)
    const showWorkflow = store.AppStore.sessionInfo?.accountPreferences?.default_case_workflow !== "NONE" && store.AppStore.checkJwtRole("account_manager")

    if (!account) return <></>

    return (
        <div className="main-menu">
            <div style={{display: "flex", gap: "14px", alignItems: "center", padding: "0 18px"}}>
                <IconButton
                    onClick={() => handleClose()}
                    className="main-menu-toggler"
                    style={{padding: "0"}}>
                    <Icons.X style={{color: "white !important", fontSize: "28px"}} />
                </IconButton>
                
                <Button component={Link} to="/app/main" className="btn">
                    {logoPath ? (
                        <img src={logoPath} style={{maxHeight: "35px", maxWidth: "170px"}} alt="Logo" />
                    ) : (
                        <Logo type="block" height="20px" color="#c0c0c0" />
                    )}
                </Button>
            </div>

            <div className="main-menu-body">
                <nav className="main-menu-nav">
                    <Button className="main-menu-link" onClick={() => store.ToolStore.tool = "account"}>
                        <Icons.Account fontSize="small" />
                        <span>Account</span>
                    </Button>

                    {store.AppStore.checkJwtRoles(["sysuser", "customer_account"], false) ? (
                        <Button className="main-menu-link" onClick={() => {
                            if (store.ToolStore.tool != "client") {
                                store.ToolStore.tool = "client"
                            } else {
                                store.ToolStore.setClient(null)
                            }
                        }}>
                            <Icons.Account fontSize="small" />
                            <span>Clients</span>
                        </Button>
                    ) : null}

                    {account.advisorUid ? (
                        <Button className="main-menu-link" onClick={() => store.ToolStore.tool = "questionnaire"}>
                            <Icons.Questionnaire fontSize="small" />
                            <span>Questionnaires</span>
                        </Button>
                    ) : null}

                    {store.AppStore.checkJwtRole("sysuser") ? (
                        <Button className="main-menu-link" onClick={() => store.ToolStore.tool = "template"}>
                            <Icons.Questionnaire fontSize="small" />
                            <span>Questionnaire Templates</span>
                        </Button>
                    ) : null}

                    <Button className="main-menu-link" onClick={() => store.ToolStore.tool = "profile"}>
                        <Icons.User fontSize="small" />
                        <span>My Details</span>
                    </Button>

                    {store.AppStore.checkJwtRole("account_manager") ? (
                        <Button className="main-menu-link" onClick={() => store.ToolStore.tool = "automation_log"}>
                            <Icons.Automation fontSize="small" />
                            <span>Automation log</span>
                        </Button>
                    ) : null}

                    {/* {store.AppStore.checkJwtRole("sysuser") ? ( */}
                        <Button className="main-menu-link" onClick={() => store.ToolStore.tool = "case_summary"}>
                            <Icons.Token fontSize="small" />
                            <span>Case summary</span>
                        </Button>
                    {/* ) : null} */}

                    {store.AppStore.checkJwtRole("sysuser") || showWorkflow ? (
                        <Button className="main-menu-link" onClick={() => store.ToolStore.tool = "workflows"}>
                            <Icons.Workflow fontSize="small" />
                            <span>Workflows</span>
                        </Button>
                    ) : null}

                    <Button className="main-menu-link" onClick={() => store.ToolStore.tool = "report"}>
                        <Icons.Report fontSize="small" />
                        <span>Reports</span>
                    </Button>

                    {supportUrl ? (
                        <Button className="main-menu-link" href={supportUrl} target="_blank" rel="noreferrer">
                            <Icons.Support fontSize="small" />
                            <span>Support</span>
                        </Button>
                    ) : null}

                    {process.env.NODE_ENV === "development" ? (
                        <Button className="main-menu-link" component={Link} to="/app/ui-demo">
                            <Icons.Component fontSize="small" />
                            <span>UI Testing</span>
                        </Button>
                    ) : null}

                    <Button className="main-menu-link" onClick={() => {store.AppStore.logout()}}>
                        <Icons.Exit fontSize="small" />
                        <span>Logout</span>
                    </Button>
                </nav>
            </div>
            
            <div className="main-menu-footer">
                <SystemInformation key={store.ConnectionStore.connectionState} />
            </div>
        </div>
    )
})